"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSessionListExportLimit = exports.EXPORT_SESSION_LIST_LIMIT_FIXED_AIR = exports.EXPORT_SESSION_LIST_LIMIT_STANDARD = void 0;
const filters_1 = require("../types/filters");
const sensors_1 = require("../types/sensors");
exports.EXPORT_SESSION_LIST_LIMIT_STANDARD = 100;
exports.EXPORT_SESSION_LIST_LIMIT_FIXED_AIR = 20;
function getSessionListExportLimit(sessionType, sensorName) {
    var _a;
    if (sessionType === filters_1.SessionTypes.MOBILE) {
        return exports.EXPORT_SESSION_LIST_LIMIT_STANDARD;
    }
    const name = (_a = sensorName === null || sensorName === void 0 ? void 0 : sensorName.toLowerCase()) !== null && _a !== void 0 ? _a : "";
    if (name.startsWith(sensors_1.SensorPrefix.GOVERNMENT.toLowerCase())) {
        return exports.EXPORT_SESSION_LIST_LIMIT_STANDARD;
    }
    if (name.startsWith(sensors_1.SensorPrefix.AIR.toLowerCase())) {
        return exports.EXPORT_SESSION_LIST_LIMIT_FIXED_AIR;
    }
    return exports.EXPORT_SESSION_LIST_LIMIT_STANDARD;
}
exports.getSessionListExportLimit = getSessionListExportLimit;
